import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function getStagingConfigs(){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_STAGING_REQUESTED", "GET_STAGING_SUCCESS", "GET_STAGING_FAILED"],
        method: "POST",
        path: "admin/get_staging_configs",
        body: data
    });
}

export function setStagingPageInfo({pageSize,pageNo}){
    return {
        type : 'SET_STAGING_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}


export function deleteStagingConfig(staging_config_id){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_staging_config = {staging_config_id: staging_config_id};
    appendTokenName(data);
    return apiAction({
        types: ["DELETE_STAGING_REQUESTED", "DELETE_STAGING_SUCCESS", "DELETE_STAGING_FAILED"],
        method: "POST",
        path: "admin/delete_staging_config",
        body: data
    });
}

export function createStagingConfig(staging_config){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_staging_config = staging_config;
    appendTokenName(data);
    return apiAction({
        types: ["CREATE_STAGING_REQUESTED", "CREATE_STAGING_SUCCESS", "CREATE_STAGING_FAILED"],
        method: "POST",
        path: "admin/create_staging_config",
        body: data
    });
}

export function updateStagingConfig(staging_config){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_staging_config = staging_config;
    appendTokenName(data);
    return apiAction({
        types: ["UPDATE_STAGING_REQUESTED", "UPDATE_STAGING_SUCCESS", "UPDATE_STAGING_FAILED"],
        method: "POST",
        path: "admin/update_staging_config",
        body: data
    });
}
